/* eslint-disable camelcase */
import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, NavigationExtras, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppInsights } from 'applicationinsights-js';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { FormGroup } from '../../../../node_modules/@angular/forms';
import { Classroom360Service } from '../../classroom360/classroom360.service';
import { Link } from '../../classroom360/links/link.model';
import { StaffService } from '../../management360/staff/staff.service';
import { EFormService } from '../../shared-components/e-forms/e-form.service';
import { Portal } from '../../shared-components/portal.model';
import { SecurityService } from '../../shared-components/security/security.service';
import { SharedService } from '../../shared-components/shared.service';
import { StudentSearchComponent } from '../../shared-components/student-search/student-search.component';
import { Student } from '../../shared-components/student/student.model';
import { TranslationService } from '../../shared-components/translation/translation.service';
import { GeneralPreferences } from '../../shared-components/user-preferences/general-preferences.model';
import { PortalMenuPreferences } from '../../shared-components/user-preferences/portal-menu-preferences.model';
import { UserPreferencesService } from '../../shared-components/user-preferences/user-preferences.service';
import { UserPermission } from '../../shared-components/user/user-permission.model';
import { UserService } from '../../shared-components/user/user.service';
import { Year } from '../../shared-components/year/year.model';
import { YearService } from '../../shared-components/year/year.service';
import { FamilyRegistrationYear } from '../family-registration/family-registration-year.model';
import { FamilyRegistrationService } from '../family-registration/family-registration.service';
import { NewFamilyRegistrationYearSelectionComponent } from '../family-registration/new-family-registration-year-selection/new-family-registration-year-selection.component';
import { RegisterNewFamilyMessageComponent } from '../family-registration/register-new-family-message/register-new-family-message.component';
import { RegisterNewFamilyComponent } from '../family-registration/register-new-family/register-new-family.component';
import { SelectLanguageComponent } from '../family-registration/select-language/select-language.component';
import { StudentService } from './../../shared-components/student/student.service';
import { AccessMessageComponent } from './access-message/access-message.component';
import { AuditLoginsComponent } from './audit-logins/audit-logins.component';
import { AuthService } from './auth.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ForgotUsernameComponent } from './forgot-username/forgot-username.component';
import { LoginOnly360Component } from './login-only360/login-only360.component';
import { LoginService } from './login.service';
import { LoginSettings } from './loginSetting.model';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UnsupportedBrowserWarningDialogComponent } from './unsupported-browser-warning-dialog/unsupported-browser-warning-dialog.component';

// Google API Variable
declare const gapi: any;
declare const google: any;

@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('userNameRef') userNameRef: ElementRef;
    badBrowser = false;
    badBrowserString: string;
    copyrightYear: number;
    loginSettings: LoginSettings;
    username = '';
    password = '';
    isLoggedIn = false;
    isLoggedInError = false;
    resetPasswordDetail: any = { isResetPasswordSaved: false };
    resetPasswordMessage = '';
    userType = 1;
    activeDirectoryAddressNotSet = false;
    loginFromLegacy = false;
    isLinkExpired = false;
    classicSetPassword = false;
    forgetPasswordParams: string[] = [];
    forgetPassword: any;
    generalPreferences: GeneralPreferences;
    showOverlay = false;
    forgotPasswordDialogRef: MatDialogRef<ForgotPasswordComponent>;
    frYearsDialogRef: MatDialogRef<NewFamilyRegistrationYearSelectionComponent>;
    selectLanguageDialogRef: MatDialogRef<SelectLanguageComponent>;
    registerFamilyMessageDialogRef: MatDialogRef<RegisterNewFamilyMessageComponent>;
    registerNewFamilyDialogRef: MatDialogRef<RegisterNewFamilyComponent>;
    ResetPasswordDialogRef: MatDialogRef<ResetPasswordComponent>;
    loginOnly360DialogRef: MatDialogRef<LoginOnly360Component, any>;
    public loginForm: FormGroup;
    tabNames: string[];
    showUserType = 0;
    defaultTabIndex = 0;
    students: Student[] = [];
    staffAssignedPortals: Portal[];
    staffPortalMenuPreferences: PortalMenuPreferences;
    staffAssignedPortalSubscription: Subscription;
    V10: boolean;
    userPermissions: UserPermission[];
    cookieAccessToken: string;
    cookieMemId: string;
    cookieUserType: string;
    usingCookie = false;
    googleAuthentication = false;
    googleScope = '';
    activateGoogleAuthenticationForStaff = false;
    activateGoogleAuthenticationForStudent = false;
    staffGoogleAuthentication = false;
    staffTID = false;
    auth2: any;
    queryStringAction = '';
    setUserIndex = new EventEmitter<number>();
    siteYearId = '';
    versionCheckInterval: any;
    subscriptions: Subscription[] = [];
    private _loginError = '';
    impersonateUser = false;
    googleError = '';
    auditLoginsComponentDialogRef: MatDialogRef<AuditLoginsComponent>;
    useTID = false;
    loginWithGoogle = false;

    constructor(
        private loginService: LoginService,
        private studentService: StudentService,
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private authService: AuthService,
        private userPreferencesService: UserPreferencesService,
        private yearService: YearService,
        private familyRegistrationService: FamilyRegistrationService,
        private dialog: MatDialog,
        private translateService: TranslateService,
        private location: Location,
        private classroom360Service: Classroom360Service,
        private zone: NgZone,
        private eFormService: EFormService,
        private translationService: TranslationService,
        private sharedService: SharedService,
        private securityService: SecurityService,
        private cookieService: CookieService,
        private staffService: StaffService
    ) {
    }

    get loginError(): string {
        return this._loginError;
    }

    set loginError(value: string) {
        // POST: sets the login error AND begins checking the version because we've failed to login
        this._loginError = value;
        if (this._loginError) {
            this.checkVersions();
        }
    }

    ngOnInit() {
        this.cookieAccessToken = this.cookieService.get('tylersis_access_token');
        this.cookieMemId = this.cookieService.get('tylersis_mem_id');
        this.cookieUserType = this.cookieService.get('tylersis_user_type');
        this.loginSettings = this.loginService.LoginSettings;
        this.V10 = this.loginService.LoginSettings.V10;
        this.userService.logoutUser();

        this.useTID = this.loginSettings.UseTID;

        // Google Authentication
        this.googleAuthentication = this.loginSettings.GoogleAuthentication && !!this.loginSettings.GoogleClientId;
        this.activateGoogleAuthenticationForStaff = this.loginSettings.ActivateGoogleAuthenticationForStaff && !!this.loginSettings.GoogleClientId;
        this.activateGoogleAuthenticationForStudent = this.loginSettings.ActivateGoogleAuthenticationForStudent && !!this.loginSettings.GoogleClientId;
        if (this.activateGoogleAuthenticationForStaff || this.activateGoogleAuthenticationForStudent) {
            this.googleAuthentication = true;
        }

        // Detecting IE
        this.subscriptions.push(this.route.queryParams.subscribe((params: Params) => {
            const impersonateAccessToken = params['impersonateAccessToken'];
            if (impersonateAccessToken) {
                sessionStorage.setItem('accessToken', impersonateAccessToken);
                this.impersonateUser = true;
            }
        }));
        if (this.detectIE()) {
            this.badBrowser = true;
            this.setUserType();
            this.setTabs();

            // If they would login in because of route params, show warning immediately
            this.subscriptions.push(this.route.queryParams.subscribe((params: Params) => {
                const action: string = params['Action'];
                const id: string = params['id'];
                if (action || id || sessionStorage.getItem('loginInformation')) {
                    this.dialog.open(UnsupportedBrowserWarningDialogComponent, {
                        disableClose: true
                    });
                }
            }));
        }

        // If this is not IE, continue
        else {
            this.initialize();
            this.checkVersions();
        }
        // Default language set to english
        this.subscriptions.push(this.loginService.resetLanguage.subscribe((result: boolean) => {
            this.userService.currentLanguage = 'en';
            this.translateService.use(this.userService.currentLanguage);
            this.translateService.setDefaultLang(this.userService.currentLanguage);
            this.translationService.getLanguageTranslations();
        }));
        this.userService.currentLanguage = 'en';
        this.translateService.use(this.userService.currentLanguage);
        this.translateService.setDefaultLang(this.userService.currentLanguage);
        this.translationService.getLanguageTranslations();
        if (
            this.staffTID && // Sri - can we trust localstorage?
            this.loginSettings.UseTID
        ) {
            this.authService.getUser().then((user) => {
                if (user) {
                    if (!user.expired) {
                        if (
                            this.staffTID == true && // Sri - can we trust localstorage?
                            this.userType == 1 &&
                            this.loginSettings.UseTID == true
                        ) {
                            this.v9TIDAuthentication(false);
                        }
                    }
                    else {
                        this.authService.login();
                    }
                }
                else {
                    this.authService.login();
                }

            });
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.userNameRef != null && (sessionStorage.getItem('loginFromLegacy') == null || sessionStorage.getItem('loginFromLegacy') != '1')) {
                this.userNameRef.nativeElement.focus();
            }

            // Google Authentication
            if (this.googleAuthentication || this.loginSettings.DisplayGoogleClassroom) {
                // Determing scopes for returned data (this is the default for now)
                if (this.loginSettings.DisplayGoogleClassroom) {
                    // It is very important that this is a space separated list
                    this.googleScope = 'https://www.googleapis.com/auth/classroom.courses ' +
                        'https://www.googleapis.com/auth/classroom.rosters ' +
                        'https://www.googleapis.com/auth/classroom.coursework.students ' +
                        'https://www.googleapis.com/auth/classroom.coursework.me ' +
                        'https://www.googleapis.com/auth/classroom.profile.emails ' +
                        'https://www.googleapis.com/auth/classroom.profile.photos ' +
                        'https://www.googleapis.com/auth/userinfo.email';
                } else {
                    this.googleScope = 'email profile openid';
                }

                if (!this.loginSettings.EnableGoogleIdentityServices) {
                    gapi.load('auth2', () => {
                        // Initializing authentication
                        gapi.auth2.init({
                            client_id: this.loginSettings.GoogleClientId.includes('.apps.googleusercontent.com') ? this.loginSettings.GoogleClientId : this.loginSettings.GoogleClientId + '.apps.googleusercontent.com',
                            cookiepolicy: 'none',
                            prompt: 'select_account',
                            ux_mode: 'popup',
                            scope: this.googleScope
                        }).then((googleAuth) => {
                            // console.log(googleAuth)
                        }, (error) => {
                            this.googleError = error.details;
                            this.loginService.googleError = this.googleError;
                            this.loginSettings.GoogleAuthentication = false;
                            this.staffGoogleAuthentication = false;
                            this.activateGoogleAuthenticationForStaff = false;
                            this.activateGoogleAuthenticationForStudent = false;
                            this.loginSettings.ActivateGoogleAuthenticationForStaff = false;
                            this.loginSettings.ActivateGoogleAuthenticationForStudent = false;
                            console.log(error);
                        });
                    });
                }
            }
        }, 0);
    }

    ngOnDestroy(): void {
        this.endCheckVersions();
    }

    checkVersions() {
        // POST: Begins checking for version on an interval
        if (!this.versionCheckInterval) {
            this.versionCheckInterval = setInterval(() => {
                this.loginService.getApplicationVersion().pipe(take(1)).subscribe((result: string) => {
                    if (result != this.loginService.LoginSettings.OneSISVersion) {
                        location.reload();
                    }
                });
            }, 300000);
        }
    }

    endCheckVersions() {
        // POST: Stops checking for the version and clears out the interval variable
        if (this.versionCheckInterval) {
            clearInterval(this.versionCheckInterval);
            this.versionCheckInterval = null;
        }
    }

    initialize() {
        this.subscriptions.push(this.route.queryParams.subscribe((params: Params) => {
            const action: string = params['Action'];
            const id: string = params['id'];
            const legacy: string = params['loginFromLegacy'];
            const code: string = params['code'];
            const eA: string = params['EA'];
            const uT: string = params['UT'];
            const iT: string = params['IT'];
            const sP: string = params['SP'];
            const GALDSAuth: string = params['GALDSAuth'];
            const redirectToEforms: string = params['NavigateToEForms'];

            if (redirectToEforms != undefined) {
                this.classroom360Service.redirectToEForms = true;
                this.eFormService.manageEformsFilter = redirectToEforms;
            }

            if (action != undefined) {
                this.loginFromLegacy = true;
                this.getClassicCurrentUser(action);
            } else if (id != undefined) {
                this.getRegisterParent(id);
            } else if (legacy) {

            } else if (code != undefined) {
                window.opener.sessionStorage.setItem('canvasCode', code);
                window.close();
            } else if (eA != undefined) {
                this.classicSetPassword = false;
                if (sP != undefined && sP == '1') {
                    this.classicSetPassword = true;
                }
                this.forgetPasswordParams.push(eA);
                this.forgetPasswordParams.push(uT);
                this.forgetPasswordParams.push(iT);
                this.getForgotPasswordDetail();
            } else if (GALDSAuth != undefined) {
                // Initiate GALDS SSO
            } else if (sessionStorage.getItem('loginInformation') != null) {
                if (sessionStorage.getItem('loginInformation').split(',').length == 2) {
                    this.userType = 2;
                    this.username = sessionStorage.getItem('loginInformation').split(',')[0];
                    this.password = sessionStorage.getItem('loginInformation').split(',')[1];
                    this.LoginButtonClick(false);
                    sessionStorage.removeItem('loginInformation');
                }
            }

            if (this.router.url.toLowerCase() != '/parent' && this.router.url.toLowerCase() != '/login/parent' && this.router.url.toLowerCase() != '/student' && this.router.url.toLowerCase() != '/login/student') {
                this.location.replaceState('login');
            }
        }));
        this.copyrightYear = new Date().getFullYear();
        this.setUserType();
        this.setTabs();
        this.setEFormsConfig();

        // If a token is provided, try to get the user
        if (this.cookieUserType) {
            localStorage.setItem('UserType', this.cookieUserType);
            this.cookieUserType = '';
        }
        if (this.cookieAccessToken) {
            sessionStorage.setItem('accessToken', this.cookieAccessToken);
            const expiredDate = new Date();
            expiredDate.setTime(expiredDate.getTime() - 86400 * 1000);
            document.cookie = 'tylersis_access_token=' + this.cookieAccessToken + ';max-age=0;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;';
            this.cookieAccessToken = '';
            this.usingCookie = true;
            sessionStorage.removeItem('loginFromLegacy');
            this.getGeneralPreferences(false);
        }
    }

    LoginButtonClick(enterClick: boolean) {
        if (this.userType == 1) {
            this.loginService.redirectingToClassic = true;
        }
        if (this.badBrowser && (this.V10 || this.userType != 1 || (!enterClick && this.loginFromLegacy && this.userType == 1))) {
            this.dialog.open(UnsupportedBrowserWarningDialogComponent, {
                disableClose: true
            });
        } else {
            this.logon(enterClick, this.username, this.password);
        }

        // Ending the interval for checking versions in case we get into the application
        this.endCheckVersions();
    }

    LoginButton360Click() {
        if (this.badBrowser) {
            this.dialog.open(UnsupportedBrowserWarningDialogComponent, {
                disableClose: true
            });
        } else {
            if (this.loginSettings.UseTID && this.staffTID) {
                this.authService.login();
            } else {
                this.loginFromLegacy = true;
                this.LoginButtonClick(false);
            }
        }
    }

    forgotUserNameClick = function () {
        this.forgotUserName = [];
        this.forgotUsernameDialogRef = this.dialog.open(ForgotUsernameComponent, {
            panelClass: 'tyl-mat-dialog',
            maxWidth: '400px',
            disableClose: true
        });

        this.subscriptions.push(this.forgotPasswordDialogRef.afterClosed().subscribe());
    };

    TabChange = function (userType: number) {
        this.userType = userType;
        $('#inputUserName').trigger('focus');
    };

    logon(enterclick: boolean, username: string, password: string): void {
        this.isLoggedInError = false;
        this.loginError = '';
        if (this.resetPasswordDetail.isResetPasswordSaved) {
            this.userType = this.userService.userType;
        }
        if (this.loginSettings.DisplaySeparateUserTypes == true && ((this.loginSettings.StaffUserUseADPassword == true && this.userType == 1) || (this.loginSettings.StudentUserUseADPassword == true && this.userType == 3)) && (this.password == undefined || this.password == null || this.password == '') && this.loginSettings.ActiveDirectoryAgentURL == '') {
            this.activeDirectoryAddressNotSet = true;
        } else {
            this.activeDirectoryAddressNotSet = false;
        }
        if (!this.activeDirectoryAddressNotSet) {
            if (this.password == undefined) {
                this.password = '';
            }
        }

        if ((this.userType == 1 && this.activateGoogleAuthenticationForStaff == true && this.staffGoogleAuthentication == true)
            || (this.userType == 3 && this.activateGoogleAuthenticationForStudent == true)) {
            this.googleUserAuthentication(enterclick);
        } else {
            this.loginService.logon(username, password, this.userType).subscribe(user => {
                if (user.userName != undefined && user.userName != null) {
                    this.setLocalStorage(user, enterclick);
                } else {
                    this.loginError = 'Invalid Username or Password.';
                    this.loginFromLegacy = false;
                }
            },
                (err) => {
                    this.isLoggedIn = false;
                    this.userService.isLoggedIn.next(false);
                    this.userService.username = '';
                    this.userService.userId = 0;
                    this.userService.firstname = '';
                    this.userService.lastname = '';
                    this.userService.userType = 0;
                    this.userService.studentId = 0;
                    this.loginFromLegacy = false;
                    if (err instanceof HttpErrorResponse && err.status == 400) {
                        this.loginError = 'Invalid Username or Password.';
                    } else {
                        this.loginError = 'There was an error during the login process.';
                        this.loginService.observableLoginError.next(err);
                    }
                });
        }
    }

    setLocalStorage(user, enterclick: boolean) {
        if (localStorage) {
            localStorage.setItem('UserType', user.userType);
        }
        sessionStorage.setItem('accessToken', user.access_token);
        AppInsights.setAuthenticatedUserContext(user.userName.replace(/[,;=| ]+/g, '_'));   // Lets app insights know what user requests come from
        if (this.username.toLocaleLowerCase() == 'sdmadmin' && this.loginService.LoginSettings.ForceSDMADMINAudit == true &&
            !this.loginService.LoginSettings.V10) {
            const auditLoginDialog = this.dialog.open(AuditLoginsComponent, {
                minHeight: '63vh',
                minWidth: '40vw',
                disableClose: true
            });
            auditLoginDialog.afterClosed().subscribe(obj => {
                this.login(user, enterclick);
            });
        }
        else {
            this.login(user, enterclick);
        }
    }

    login(user, enterclick: boolean) {
        this.isLoggedIn = true;
        this.userService.isLoggedIn.next(true);
        this.userService.username = user.userName;
        this.userService.firstname = user.firstName;
        this.userService.lastname = user.lastName;
        this.userService.userId = user.userId;
        this.userService.userType = user.userType;
        this.userService.studentId = user.studentId;
        this.userService.forceUserToClassic = user.forceToClassic == 'true';


        if (user.userType == '1') {
            this.getGeneralPreferences(enterclick);
            if (!this.loginSettings.V10) {
                this.getDefaultYear(this.userService.userId);
                if (!this.impersonateUser) {
                    if (sessionStorage.getItem('impersonateUseraccessToken') != null && sessionStorage.getItem('loginFromLegacy') != null) {
                        sessionStorage.removeItem('loginFromLegacy');
                    }
                    sessionStorage.setItem('impersonateUseraccessToken', user.access_token);
                }
            }
        } else {
            this.getUser(enterclick);
        }
    }


    getUser(enterClick: boolean) {
        this.subscriptions.push(this.loginService.getUser().subscribe(user => {
            this.loginService.observableLogin.next();
            if (this.loginSettings.V10 == false) {
                if (user.UserIsLocked == false && user.UserIsDisabled == false) {
                    if (user.UserType == 1 && user.UserIsTeacher == true && user.UserCanAccessClassroom == false) {
                        this.loginSettings.ActivateClassroom360 = false;
                        this.loginService.LoginSettings.ActivateClassroom360 = false;
                    }

                    if (this.userType == 1 && this.loginSettings.DisplaySeparateUserTypes == true && this.loginFromLegacy == false) {
                        this.userService.currentUser = user;
                        this.getUserDefaultSchoolYearIsBlocked(enterClick);
                    } else {
                        this.userService.currentUser = user;
                        this.redirectUserTo360();
                    }
                } else if (user.UserIsDisabled) {
                    this.loginError = 'User ' + user.UserName + ' - Account has been disabled';
                    this.loginFromLegacy = false;
                } else if (user.UserIsLocked) {
                    this.loginError = 'User ' + user.UserName + ' - Account is not currently active';
                    this.loginFromLegacy = false;
                }
            } else {
                if (user.UserIsLocked == false && user.UserIsDisabled == false) {
                    const legacyUrl = this.loginService.LoginSettings.LegacyURL;
                    if (!this.loginService.LoginSettings.ActivateStudent360 && !this.loginService.LoginSettings.ActivateClassroom360 && legacyUrl != '') {
                        // window.removeEventListener('beforeunload', confirmExit);
                        this.showOverlay = true;
                        window.location.replace(legacyUrl + '?LoginFrom360=Y');
                    }
                    // else if (user.UserType == 1 && this.loginService.LoginSettings.UseUnifiedLoginPage && legacyUrl != '' && this.userService.forceUserToClassic) {
                    //     this.showOverlay = true;
                    //     window.location.replace(legacyUrl + '?LoginFrom360=Y');
                    // }
                    else if (user.UserType == 1 && !this.loginService.LoginSettings.RedirectTeachersTo360 && legacyUrl != '' && this.loginFromLegacy != true && legacyUrl != '' && this.loginService.LoginSettings.UseUnifiedLoginPage) {
                        // window.removeEventListener('beforeunload', confirmExit);
                        this.showOverlay = true;
                        window.location.replace(legacyUrl + '?LoginFrom360=Y');

                    } else if (user.UserType == 1 && (!user.UserIsTeacher || this.userService.forceUserToClassic) && this.loginFromLegacy != true && legacyUrl != '' && this.loginService.LoginSettings.UseUnifiedLoginPage) {
                        // window.removeEventListener('beforeunload', confirmExit);
                        this.showOverlay = true;
                        window.location.replace(legacyUrl + '?LoginFrom360=Y');
                    } else if ((user.UserType == 2 || user.UserType == 3) && !this.loginService.LoginSettings.ActivateStudent360 && legacyUrl != '') {
                        // window.removeEventListener('beforeunload', confirmExit);
                        this.showOverlay = true;
                        window.location.replace(legacyUrl + '?LoginFrom360=Y');
                    } else {
                        if (this.studentService.legacySelectedStudentId > 0) {
                            user.StudentId = this.studentService.legacySelectedStudentId;
                        }
                        this.userService.currentUser = user;
                        this.isLoggedIn = true;
                        this.userService.isLoggedIn.next(true);
                        this.userService.username = user.UserName;
                        this.userService.firstname = user.FirstName;
                        this.userService.lastname = user.LastName;
                        this.userService.userId = user.Id;
                        this.userService.userType = user.UserType;
                        this.userService.studentId = user.StudentId;

                        let userId = this.userService.userId;
                        if (this.userService.userType == 3 && userId == 0) {
                            userId = this.userService.studentId;
                        }
                        this.saveUserLoginInfo(userId);
                        if (this.userService.userType != 1) {
                            this.setUserLanguage();
                        }
                        this.getUserYears();
                    }
                } else if (user.UserIsDisabled) {
                    this.loginError = (this.loginService.LoginSettings.V10) ? 'User account is not currently active.' : 'User ' + user.UserName + ' - Account has been disabled';
                    this.loginFromLegacy = false;
                } else if (user.UserIsLocked) {
                    this.loginError = (this.loginService.LoginSettings.V10) ? 'User account is currently locked.' : 'User ' + user.UserName + ' - Account is not currently active';
                    this.loginFromLegacy = false;
                } else {
                    this.loginError = 'User account not found.';
                    this.loginFromLegacy = false;
                }
            }
        }));
    }

    getUserLinks(id: number, yearId: any) {
        if (!this.V10) {
            yearId = this.yearService.defaultYear.Id;
        }
        if (this.V10) {
            // v10
            if (this.userService.userType != 1) {
                // Parent/Student
                this.userService.getParentStudentLinks(id, yearId).pipe(take(1)).subscribe(response => {
                    // create a new link object for each object in the response body
                    if (response.body != null) {
                        for (let i = 0; i < response.body.length; i++) {
                            const bLink = response.body[i];
                            const link = new Link();
                            link.LinkName = bLink.Description;
                            link.Link_ID = bLink.Id;
                            link.OpenAsHTTPS = bLink.OpenAsHTTPS;
                            link.OpenAsNewWindow = bLink.OpenAsNewWindow;
                            link.LinkUrl = bLink.WebAddress;
                            link.IsDistrictLevel = 'Yes';
                            this.userService.links.push(link);
                        }
                    }
                });
            } else {
                // Staff
                this.userService.getLinks(id, 0, yearId).pipe(take(1)).subscribe(response => {
                    this.userService.links = response.body;
                });
            }
        } else {
            // v9
            this.userService.getParentStudentLinks(id, yearId).pipe(take(1)).subscribe(response => {
                // create a new link object for each object in the response body
                if (response.body != null) {
                    for (let i = 0; i < response.body.length; i++) {
                        const bLink = response.body[i];
                        const link = new Link();
                        link.LinkName = bLink.Description;
                        link.Link_ID = bLink.Id;
                        link.OpenAsHTTPS = bLink.OpenAsHTTPS;
                        link.OpenAsNewWindow = bLink.OpenAsNewWindow;
                        link.LinkUrl = bLink.WebAddress;
                        link.IsDistrictLevel = 'No';
                        this.userService.links.push(link);
                    }
                }
            });
        }
    }

    getUserFavorites() {
        this.userPreferencesService.getUserPreferences(0, '/OneSISFavorites').pipe(take(1)).subscribe(data => {
            this.userPreferencesService.favoritesPreferences = JSON.parse(data[0]);
        }, err => {
            console.log(err);
        }, () => {
        });
    }

    getDefaultYear(userId: number) {
        // TODO: forkJoin other default years here
        this.subscriptions.push(this.userService.getDefaultYear(userId).subscribe((year: Year) => {
            this.yearService.defaultYear = year;
            this.yearService.student360Year = year;
            this.yearService.loginYear = year;
        }));
    }

    getDistrictSchools() {
        this.yearService.getAllSchools().pipe(take(1)).subscribe(schools => {
            this.yearService.allDistrictSchools = schools;
        });
    }

    getUserYears() {
        // eslint-disable-next-line complexity
        this.subscriptions.push(this.yearService.getUserYears(this.userService.currentUser.Id, this.userService.currentUser.UserType, !this.loginSettings.V10 && this.studentService.legacySelectedStudentId != null && this.studentService.legacySelectedStudentId > 0 ? this.studentService.legacySelectedStudentId : this.userService.studentId).subscribe(years => {
            if (years.length == 0) {
                this.loginError = 'User is not assigned any Academic Years.';
                this.loginFromLegacy = false;
            } else {
                this.yearService.setCurrentAttendanceDate(years);
                const defaultYear = years.filter(y => y.Default)[0];
                let impersonateYear: Year;
                if (this.V10 == false && this.siteYearId != undefined && this.siteYearId != null && this.siteYearId != '') {
                    impersonateYear = years.filter(y => y.SiteYearId == Number(this.siteYearId))[0];
                }
                if (this.V10 == true || defaultYear != null || (impersonateYear != null && impersonateYear != undefined)) {
                    this.yearService.defaultYear = (impersonateYear != null && impersonateYear != undefined) ? impersonateYear : defaultYear;
                    this.yearService.student360Year = (impersonateYear != null && impersonateYear != undefined) ? impersonateYear : defaultYear;
                    this.yearService.loginYear = (impersonateYear != null && impersonateYear != undefined) ? impersonateYear : defaultYear;
                    this.yearService.loadYears(years);
                    if (this.V10 == false) {
                        this.yearService.loadYearsForC360(years);
                    }
                    this.securityService.loadUserPermissions();
                    this.yearService.years = years;
                    if (this.userService.userType == 1) {
                        this.getDistrictSchools();
                    }
                    this.getUserFavorites();
                    if (this.V10) {
                        this.getUserLinks(this.userService.currentUser.Id, this.yearService.defaultYear.AYIdentifier);
                    } else if (this.userService.currentUser.UserType == 1) {
                        this.getUserLinks(0, this.yearService.defaultYear.Id);
                    }
                } else {
                    this.getUserDefaultSchoolYearIsBlocked(false);
                    this.loginFromLegacy = false;
                    return;
                }
            }
            if (this.userService.currentUser.NewFamilyRegistration) {
                this.getStudents(() => {
                    this.router.navigateByUrl('/student360/onlineRegistration');
                });
            } else if (this.userService.currentUser.UserType != 1) {
                this.getStudents(() => {
                    if (this.studentService.students.length > 0) {
                        if (!this.usingCookie && (this.userService.currentUser.ForceChangePassword || this.userService.currentUser.ForceChangeExpiredPass) && (this.userService.currentUser.UserType != 3 || (this.loginSettings.StudentUserUseADPassword == false && this.loginSettings.ActivateGoogleAuthenticationForStudent == false))) {
                            this.router.navigateByUrl('/changePassword');
                        } else {
                            this.router.navigateByUrl('/student360');
                        }
                        if (this.V10) {
                            this.getUserLinks(this.studentService.selectedStudent.Id, this.yearService.defaultYear.Id);
                        }
                        else {
                            const studentId = (this.userService.userType == 3) ? this.studentService.selectedStudent.Id : 0;
                            this.getUserLinks(studentId, this.yearService.defaultYear.Id);
                        }
                    } else {
                        this.isLoggedInError = true;
                        if (this.userService.userType == 3) {
                            this.loginError = 'Portal is not activated for the year(s) you are enrolled.';
                            this.loginFromLegacy = false;
                        } else if (this.yearService.defaultYear.V10Flag && this.userService.userType == 2) {
                            this.loginError = 'Portal not activated for year(s) in which student(s) are enrolled.';
                            this.loginFromLegacy = false;
                        } else {
                            if (this.yearService.defaultYear.V10Flag) {
                                this.loginError = 'Portal not activated for year(s) in which student(s) are enrolled.';
                                this.loginFromLegacy = false;
                            } else {
                                this.loginError = 'Student(s) Not Enrolled in Portal Default School Year';
                                this.loginFromLegacy = false;
                            }
                        }
                    }
                });
            } else {
                if (this.loginSettings.V10) {
                    if (sessionStorage.getItem('loginFromLegacy') != null || sessionStorage.getItem('loginFromLegacy') == '1') {
                        this.getGeneralPreferences(false);
                    }

                    if (!this.usingCookie && (this.userService.currentUser.ForceChangePassword || this.userService.currentUser.ForceChangeExpiredPass)) {
                        this.router.navigateByUrl('/changePassword');
                    } else {
                        this.router.navigateByUrl('/classroom360');
                    }
                } else {
                    if (this.userService.userType == 1) {
                        if (sessionStorage.getItem('loginFromLegacy') != null || sessionStorage.getItem('loginFromLegacy') == '1') {
                            this.getGeneralPreferences(false);
                        }
                    }
                    if (this.userService.userType == 1 && this.loginSettings.ActivateClassroom360 && this.loginSettings.ActivateBehavior360 == true && this.queryStringAction != null && this.queryStringAction != '') {
                        if (this.queryStringAction.toUpperCase() == 'Behavior'.toUpperCase() || this.queryStringAction.toUpperCase() == 'Discipline'.toUpperCase()) {
                            this.router.navigateByUrl('/counselor360/behavior/behaviorEvents');
                        } else if (this.queryStringAction.toUpperCase() == 'Incident_NAA'.toUpperCase()) {
                            this.router.navigateByUrl('/counselor360/behavior/behaviorEvents?calledFromCard=true');
                        } else if (this.queryStringAction.toUpperCase() == 'Referral'.toUpperCase()) {
                            this.router.navigateByUrl('/classroom360/behaviorReferral');
                        } else if (this.queryStringAction.toUpperCase() == 'Referrallink'.toUpperCase()) {
                            const navigationExtras: NavigationExtras = {
                                queryParams: {
                                    'referrallink': true
                                }
                            };
                            this.router.navigate(['/classroom360/behaviorReferral'], navigationExtras);
                        } else if (this.queryStringAction.toUpperCase() == 'Referral_WA'.toUpperCase() || this.queryStringAction.toUpperCase() == 'Referral_AR'.toUpperCase()) {
                            const navigationExtras: NavigationExtras = {
                                queryParams: {
                                    'referrallink': true,
                                    'referralStatus': this.queryStringAction
                                }
                            };
                            this.router.navigate(['/classroom360/behaviorReferral'], navigationExtras);
                        } else if (this.queryStringAction.toUpperCase() == 'EForms_C'.toUpperCase() || this.queryStringAction.toUpperCase() == 'EForms_R'.toUpperCase()) {
                            const navigationExtras: NavigationExtras = {
                                queryParams: {
                                    'referrallink': true,
                                    'referralStatus': this.queryStringAction
                                }
                            };
                            if (this.queryStringAction.toUpperCase() == 'EForms_C'.toUpperCase()) {
                                this.eFormService.manageEformsFilter = 'accepted';
                            }
                            if (this.queryStringAction.toUpperCase() == 'EForms_R'.toUpperCase()) {
                                this.eFormService.manageEformsFilter = 'submitted';
                            }
                            this.eFormService.redirectFromClassic = true;
                            this.router.navigate(['/admin360/eForms/processing/'], navigationExtras);
                        } else if (this.queryStringAction.toUpperCase() == 'PermissionModifedIn360'.toUpperCase()) {
                            this.router.navigateByUrl('/management360/staff/staffAdministration');
                        }

                        setTimeout(() => {
                            this.sharedService.updateIsPageLoaded(true);
                        }, 100);
                    } else if (this.userService.userType == 1 && this.loginSettings.ActivateClassroom360 && (this.studentService.legacySelectedStudentId == 0)) {
                        if (!this.usingCookie && (this.userService.currentUser.ForceChangePassword || this.userService.currentUser.ForceChangeExpiredPass) && this.loginSettings.StaffUserUseADPassword == false && this.loginSettings.ActivateGoogleAuthenticationForStaff == false) {
                            this.router.navigateByUrl('/changePassword');
                        } else {
                            this.router.navigateByUrl('/classroom360');
                        }
                    } else {
                        if (this.studentService.legacySelectedStudentId != null && this.studentService.legacySelectedStudentId > 0) {
                            this.studentService.getStudent(+this.studentService.legacySelectedStudentId).subscribe(student => {
                                this.studentService.selectedStudent = student;
                                this.students.push(student);
                                this.studentService.updateStudents(this.students);
                                this.router.navigateByUrl('/student360/studentSummary');
                            });
                        } else {
                            if (!this.usingCookie && (this.userService.currentUser.ForceChangePassword || this.userService.currentUser.ForceChangeExpiredPass) && this.loginSettings.StaffUserUseADPassword == false && this.loginSettings.ActivateGoogleAuthenticationForStaff == false) {
                                this.router.navigateByUrl('/changePassword');
                            } else {
                                this.dialog.open(StudentSearchComponent,
                                    {
                                        data: {
                                            performRoute: true,
                                            searchAndSelect: false
                                        },
                                        width: '100%',
                                        height: '100%',
                                        maxHeight: '100vh',
                                        maxWidth: '100vw',
                                        disableClose: true
                                    }
                                );
                            }

                            setTimeout(() => {
                                if (this.userService.currentUser.UserType == 1 && this.loginService.LoginSettings.BlockClassroom360) {
                                    this.dialog.open(AccessMessageComponent, {
                                        panelClass: 'tyl-mat-dialog',
                                        maxWidth: '500px',
                                        disableClose: true
                                    });
                                }
                            }, 0);
                        }
                    }
                }
            }
        }));
    }

    getStudents(callback: Function) {
        let userId: number = this.userService.userId;
        if (this.userService.currentUser.UserType == 3 && userId == 0) {
            userId = this.userService.studentId;
        }
        this.subscriptions.push(this.studentService.getParentAssignedStudents(userId, this.yearService.defaultYear.Id, this.userService.currentUser.UserType).subscribe((students: Student[]) => {
            this.studentService.updateStudents(students);
            callback(students);
        }));
    }

    getClassicCurrentUser(action: string) {
        this.queryStringAction = '';
        if (this.loginSettings.V10 != undefined) {
            try {
                const decryptAction = window.atob(action);
                const splitParameter = decryptAction.split('&');
                if (splitParameter.length > 1) {
                    this.siteYearId = splitParameter[1].split('=')[1];
                }
                // if (decryptAction != null && (decryptAction.toUpperCase() == 'Behavior'.toUpperCase() || decryptAction.toUpperCase() == 'Referral'.toUpperCase() || decryptAction.toUpperCase() == 'Discipline'.toUpperCase() || decryptAction.toUpperCase() == 'Referrallink'.toUpperCase() || splitParameter[0].toUpperCase() == 'Referral_AR'.toUpperCase() || splitParameter[0].toUpperCase() == 'Referral_WA'.toUpperCase() || splitParameter[0].toUpperCase() == 'Referral'.toUpperCase() || splitParameter[0].toUpperCase() == 'Discipline'.toUpperCase() || splitParameter[0].toUpperCase() == 'Behavior'.toUpperCase())) {
                if (decryptAction != null && (decryptAction.toUpperCase() == 'Behavior'.toUpperCase()
                    || decryptAction.toUpperCase() == 'Referral'.toUpperCase() || decryptAction.toUpperCase() == 'Discipline'.toUpperCase()
                    || decryptAction.toUpperCase() == 'Referrallink'.toUpperCase()
                    || decryptAction.toUpperCase() == 'Incident_NAA'.toUpperCase()
                    || splitParameter[0].toUpperCase() == 'Referral_AR'.toUpperCase()
                    || splitParameter[0].toUpperCase() == 'Referral_WA'.toUpperCase() || splitParameter[0].toUpperCase() == 'Referral'.toUpperCase()
                    || splitParameter[0].toUpperCase() == 'Discipline'.toUpperCase() || splitParameter[0].toUpperCase() == 'Behavior'.toUpperCase()
                    || splitParameter[0].toUpperCase() == 'EForms_C'.toUpperCase() || splitParameter[0].toUpperCase() == 'EForms_R'.toUpperCase()
                    || splitParameter[0].toUpperCase() == 'Incident_NAA'.toUpperCase())
                ) {
                    this.queryStringAction = (splitParameter != undefined && splitParameter.length > 0) ? splitParameter[0] : decryptAction;
                } else if (decryptAction != null && (splitParameter[0].toUpperCase() == 'PERMISSIONMODIFEDIN360')) {
                    this.staffService.legacySelectedStaffId = Number(splitParameter[2].split('=')[1]);
                    this.queryStringAction = (splitParameter != undefined && splitParameter.length > 0) ? splitParameter[0] : decryptAction;
                } else if (decryptAction != null && decryptAction.split(':').length > 1) {
                    const legacySelectedStudentId = decryptAction.split(':')[1];
                    this.studentService.legacySelectedStudentId = Number(legacySelectedStudentId);
                }
            } catch (e) {
                this.studentService.legacySelectedStudentId = 0;
            }
            sessionStorage.setItem('loginFromLegacy', '1');
            this.getUser(true);
        } else {
            setTimeout(() => {
                this.getClassicCurrentUser(action);
            }, 50);
        }
    }

    getRegisterParent(id) {
        this.subscriptions.push(this.loginService.getRegisterParent(id).subscribe((result) => {
            if (result) {
                // this.location.url(this.location.path());
                this.familyRegistrationService.householdParent = result;

                this.userService.currentLanguage = 'en';
                if (this.familyRegistrationService.householdParent.Language == 2) {
                    this.userService.currentLanguage = 'fr';
                } else if (this.familyRegistrationService.householdParent.Language == 3) {
                    this.userService.currentLanguage = 'es';
                } else if (this.familyRegistrationService.householdParent.Language == 4) {
                    this.userService.currentLanguage = 'pt';
                }

                this.translateService.use(this.userService.currentLanguage);
                this.translateService.setDefaultLang(this.userService.currentLanguage);
                this.translationService.getLanguageTranslations();


                this.familyRegistrationService.getORYears().subscribe((years: FamilyRegistrationYear[]) => {
                    this.familyRegistrationService.years = years;
                    if (this.familyRegistrationService.years.length != 0) {
                        if ((this.loginService.LoginSettings.V10 && this.familyRegistrationService.householdParent.AyIdentifier != null && this.familyRegistrationService.householdParent.AyIdentifier != '') || (!this.loginService.LoginSettings.V10 && this.familyRegistrationService.householdParent.YearId > 0)) {
                            if (this.loginService.LoginSettings.V10) {
                                this.familyRegistrationService.defaultYear = this.familyRegistrationService.years.find(o => o.AYIdentifier == this.familyRegistrationService.householdParent.AyIdentifier);
                            } else {
                                this.familyRegistrationService.defaultYear = this.familyRegistrationService.years.find(o => o.Id == this.familyRegistrationService.householdParent.YearId);
                            }
                            if (this.familyRegistrationService.defaultYear) {
                                this.router.navigateByUrl('/familyregistration/householdparent');
                            }
                        } else {
                            if (this.loginService.LoginSettings.V10) {
                                const currentDate = new Date();
                                for (let i = 0; i < this.familyRegistrationService.years.length; i++) {
                                    if (this.familyRegistrationService.years[i].Status == 1) {
                                        if (this.familyRegistrationService.years[i].StartDate < currentDate) {
                                            this.familyRegistrationService.years[i].Status = 3;
                                        }
                                    }
                                }
                            }

                            if (this.familyRegistrationService.years.length > 1) {
                                this.frYearsDialogRef = this.dialog.open(NewFamilyRegistrationYearSelectionComponent, {
                                    disableClose: true,
                                    maxWidth: '500px'
                                });
                            } else {
                                this.familyRegistrationService.defaultYear = this.familyRegistrationService.years[0];
                                this.familyRegistrationService.householdParent.YearId = this.familyRegistrationService.defaultYear.Id;
                                this.familyRegistrationService.householdParent.AyIdentifier = this.loginService.LoginSettings.V10 ? this.familyRegistrationService.defaultYear.AYIdentifier : this.familyRegistrationService.defaultYear.Description;

                                this.frYearsDialogRef = this.dialog.open(NewFamilyRegistrationYearSelectionComponent, {
                                    disableClose: true,
                                    maxWidth: '500px'
                                });
                            }
                        }
                    }
                });
            }
        }));
    }

    getGeneralPreferences(enterClick: boolean) {
        this.userPreferencesService.getUserPreferences(0, '/OneSISGeneralPreferences', 0, '0').pipe(take(1)).subscribe((data: string) => {
            const pref: GeneralPreferences = JSON.parse(data);
            this.userPreferencesService.generalPreferences = pref;
            if (enterClick) {
                if (pref.DefaultLoginScreen == 'Classic') {// && !this.userService.forceUserToClassic) {
                    this.loginFromLegacy = false;
                } else {
                    if (this.badBrowser) {
                        this.dialog.open(UnsupportedBrowserWarningDialogComponent, {
                            disableClose: true
                        });
                        return;
                    } else {
                        this.loginFromLegacy = true;
                    }
                }
            }
            if (sessionStorage.getItem('loginFromLegacy') == null || sessionStorage.getItem('loginFromLegacy') != '1') {
                this.getUser(enterClick);
            }
        });
    }

    getForgotPasswordDetail() {
        this.subscriptions.push(this.loginService.getForgetPasswordDetail(this.forgetPasswordParams).subscribe(
            (result: object) => { // success
                this.forgetPassword = result;
                this.userType = this.forgetPassword.UserType;
                if (this.forgetPassword.Id == -1 && this.forgetPassword.StudentId == -1) {
                    this.isLinkExpired = true;
                    this.resetPasswordMessage = this.forgetPassword.LastName;
                    this.setUserIndex.emit(this.userType - 1);
                } else if (this.forgetPassword.LastName == 'success') {
                    this.resetPasswordMessage = '';
                    if (this.forgetPassword.UserType != 3) {
                        this.userService.userId = this.forgetPassword.Id;
                    } else {
                        this.userService.studentId = this.forgetPassword.StudentId;
                    }
                    this.userType = this.forgetPassword.UserType;
                    this.userService.userType = this.forgetPassword.UserType;
                    this.userService.studentId = this.forgetPassword.studentId;
                    this.userService.username = this.forgetPassword.UserName;
                    this.userService.password = this.forgetPassword.Password;
                    this.setUserIndex.emit(this.userType - 1);
                }
            },
            (err) => {
            }, // fail
            () => { // then
                if (this.classicSetPassword && this.resetPasswordMessage != null && this.resetPasswordMessage != '') {
                    this.userService.userType = this.userType;
                }
                this.ResetPasswordDialogRef = this.dialog.open(ResetPasswordComponent, {
                    disableClose: true,
                    width: this.isLinkExpired ? '500px' : '400px',
                    data: {
                        user: this.forgetPassword,
                        forgotPasswordParams: this.forgetPasswordParams,
                        isLinkExpired: this.isLinkExpired,
                        resetPasswordMessage: this.resetPasswordMessage
                    }
                });
            }
        ));
    }

    getUserDefaultSchoolYearIsBlocked(enterClick: boolean) {
        this.subscriptions.push(this.loginService.getUserDefaultSchoolYearIsBlocked().subscribe(result => {
            if (result != null && result != '') {
                this.loginError = 'Login to Site-Year' + result + ' is blocked';
            } else {
                if (this.loginFromLegacy == false && this.loginSettings.DisplaySeparateUserTypes == true && this.userType == 1) {
                    this.getUserPermissions(enterClick);
                }
            }
        }));
    }

    saveUserLoginInfo(userId: number) {
        this.loginService.saveUserLoginInfo(userId, this.userService.userType, window.innerHeight, window.innerWidth, 1, '');
    }

    setUserLanguage() {
        this.userService.getUserLanguage();
    }

    setTabs() {
        this.tabNames = [];
        if (this.showUserType == 0) {
            this.tabNames.push('Staff');
        }
        if (this.loginSettings.ParentPortalShowParentTab && (this.showUserType == 0 || this.showUserType == 2)) {
            this.tabNames.push('Parent');
        }
        if (this.loginSettings.ParentPortalShowStudentTab && (this.showUserType == 0 || this.showUserType == 3)) {
            this.tabNames.push('Student');
        }
        switch (this.userType) {
            case 1: {
                this.defaultTabIndex = this.tabNames.indexOf('Staff');
                break;
            }
            case 2: {
                this.defaultTabIndex = this.tabNames.indexOf('Parent');
                break;
            }
            case 3: {
                this.defaultTabIndex = this.tabNames.indexOf('Student');
                break;
            }
        }

        if (this.defaultTabIndex == -1) {
            this.defaultTabIndex = 0;
            this.userType = 1;
        }
    }

    setUserType = function () {
        if (localStorage) {
            if (localStorage.getItem('UserType')) {
                this.userType = parseInt(localStorage.getItem('UserType'), 10);
            }
            if (this.activateGoogleAuthenticationForStaff == true && localStorage.getItem('StaffGoogleAuthentication')) {
                this.staffGoogleAuthentication = localStorage.getItem('StaffGoogleAuthentication').toLowerCase() == 'true';
            }
            if (this.loginSettings.UseTID == true && localStorage.getItem('staffTID')) {
                this.staffTID =
                    localStorage.getItem('staffTID').toLowerCase() == 'true';
            }
        }
        if ((this.router.url.toLowerCase() == '/parent' || this.router.url.toLowerCase() == '/login/parent') && this.loginService.LoginSettings.ParentPortalShowParentTab == true) {
            this.userType = 2;
            this.showUserType = 2;
        } else if ((this.router.url.toLowerCase() == '/student' || this.router.url.toLowerCase() == '/login/student') && this.loginService.LoginSettings.ParentPortalShowStudentTab == true) {
            this.userType = 3;
            this.showUserType = 3;
        } else {
            this.showUserType = 0;
        }
    };

    tabChange(e: string) {
        switch (e) {
            // DO NOT ACCESS THE USER SERVICE FROM HERE
            case 'Staff': {
                this.userType = 1;
                break;
            }
            case 'Parent': {
                this.userType = 2;
                break;
            }
            case 'Student': {
                this.userType = 3;
                break;
            }
        }
    }

    forgotPasswordClick() {
        this.classicSetPassword = false;
        if (this.router.url == '/loginassist') {
            this.loginService.LoginSettings.ShowForgotUserNameLink = false;
        }
        this.forgotPasswordDialogRef = this.dialog.open(ForgotPasswordComponent, {
            disableClose: true,
            maxWidth: '400px',
            data: { userType: this.userType }
        });
    }

    registerNewFamilyClick() {
        // PRE: the user tries to register a new family
        // POST: checks the browser. If okay, then opens dialog for registration process.

        // Show an error if this is IE
        if (this.badBrowser) {
            this.dialog.open(UnsupportedBrowserWarningDialogComponent, {
                disableClose: true
            });
        }

        // Otherwise, start new family registration process
        else {
            this.familyRegistrationService.registerNewFamily = {};
            this.familyRegistrationService.registerNewFamily.language = 'en';
            this.familyRegistrationService.registerNewFamily.emailAddress = '';
            this.openNewFamilyRegistrationPopup('Select Language');
        }
    }

    openNewFamilyRegistrationPopup(window: string) {
        switch (window) {
            case 'Select Language': {
                this.selectLanguageDialogRef = this.dialog.open(SelectLanguageComponent, {
                    disableClose: true,
                });
                this.subscriptions.push(this.selectLanguageDialogRef.afterClosed().subscribe(result => {
                    this.openNewFamilyRegistrationPopup(result);
                }));
                break;
            }
            case 'Register New Family Message': {
                this.registerFamilyMessageDialogRef = this.dialog.open(RegisterNewFamilyMessageComponent, {
                    maxHeight: '50vh',
                    maxWidth: '40vw',
                    disableClose: true,
                });
                this.subscriptions.push(this.registerFamilyMessageDialogRef.afterClosed().subscribe(result => {
                    this.openNewFamilyRegistrationPopup(result);
                }));
                break;
            }
            case 'Register New Family': {
                this.registerNewFamilyDialogRef = this.dialog.open(RegisterNewFamilyComponent, {
                    disableClose: true,
                });
                this.subscriptions.push(this.registerNewFamilyDialogRef.afterClosed().subscribe(result => {
                    this.openNewFamilyRegistrationPopup(result);
                }));
                break;
            }
            case 'Cancel was clicked.': {
                this.userService.currentLanguage = 'en';
                this.translateService.use(this.userService.currentLanguage);
                this.translateService.setDefaultLang(this.userService.currentLanguage);
                this.translationService.getLanguageTranslations();
                break;
            }
            default: {
                break;
            }
        }
    }

    getUserPermissions(enterClick: boolean) {
        // POST: obtains the permissions from the server
        this.subscriptions.push(
            this.userService.getUserPermissions(this.userService.currentUser.LoginYearId, this.userService.currentUser.LoginSchoolId).subscribe(permissions => {
                this.userPermissions = permissions;
                const forceTeachersDate = this.loginService.LoginSettings.ForceTeachersDate;

                if (this.userService.currentUser.UserIsTeacher && forceTeachersDate != null && new Date(forceTeachersDate) <= new Date()
                    && this.userPermissions.filter(o => o.PermissionCode == 'NSE_VSH' || o.PermissionCode == 'GO_VFMMNJTM').length == 0
                ) {
                    this.redirectUserTo360();
                }
                else if (this.userPermissions.find(permission => permission.PermissionName == 'Login only to 360')) {
                    if (!enterClick) {
                        this.loginOnly360DialogRef = this.dialog.open(LoginOnly360Component, {
                            panelClass: 'tyl-mat-dialog',
                            maxWidth: '500px',
                            disableClose: true
                        });
                        this.loginOnly360DialogRef.afterClosed().subscribe(result => {
                            this.redirectUserTo360();
                        });
                    } else {
                        this.redirectUserTo360();
                    }
                } else {
                    window.localStorage.setItem('NewApplication', '1');
                    const legacyUrl = window.location.href.substr(0, window.location.href.indexOf('360'));
                    window.location.href = legacyUrl + '/SwitchToClassic.aspx';

                    if (sessionStorage.getItem('ClassicLoginAttempt') != null && sessionStorage.getItem('ClassicMTUrl') != null && sessionStorage.getItem('ClassicMTUrl').toLowerCase() == legacyUrl.toLowerCase()) {
                        sessionStorage.setItem('ClassicLoginAttempt', (Number(sessionStorage.getItem('ClassicLoginAttempt')) + 1).toString());
                    } else {
                        sessionStorage.setItem('ClassicLoginAttempt', '1');
                    }
                }
            }));
    }

    detectIE() {
        // POST: returns true if this is IE
        const ua = window.navigator.userAgent;

        // Test values; Uncomment to check result …

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // Edge 12 (Spartan)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge 13
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKmozillamozillamozillamozillait/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        const msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return true;
        }

        const trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            const rv = ua.indexOf('rv:');
            return true;
        }

        const edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return false;
        }

        // other browser
        return false;
    }

    setEFormsConfig() {
        if (this.loginService.LoginSettings.V10) {
            this.loginService.LoginSettings.EFormNonResident = false;
            this.loginService.LoginSettings.EFormUseRoles = true;
        } else {
            this.loginService.LoginSettings.EFormNonResident = true;
            this.loginService.LoginSettings.EFormUseRoles = false;
        }
    }

    staffGoogleAuthenticationChange() {
        if (this.staffGoogleAuthentication == true) {
            this.username = '';
            this.password = '';
        }
        localStorage.setItem('StaffGoogleAuthentication', this.staffGoogleAuthentication.toString());
    }

    staffTIDChange() {
        if (this.staffTID == true) {
            this.username = '';
            this.password = '';
        }
        localStorage.setItem('staffTID', this.staffTID.toString());
    }

    googleUserAuthentication(enterClick: boolean) {
        this.loginWithGoogle = true;
        if (!this.loginSettings.EnableGoogleIdentityServices) {
            gapi.auth2.getAuthInstance().signIn().then(
                (googleUser) => {
                    // Loading the user's ID token
                    const idToken = googleUser.getAuthResponse().id_token;
                    this.validateGoogleToken(idToken, enterClick, 'google_oAuth');
                },
                // This is called when the user fails to log into google
                (googleError) => {
                    this.loginFromLegacy = false;
                    if (googleError.error != 'popup_closed_by_user') {
                        this.zone.run(() => {
                            this.loginError = 'Invalid Google login.';
                            this.loginWithGoogle = false;
                        });
                    }
                }
            );
        }
        else {
            let clientId = this.loginSettings.GoogleClientId;
            if (!clientId.includes('.apps.googleusercontent.com')) {
                clientId = clientId + '.apps.googleusercontent.com';
            }

            const client = google.accounts.oauth2.initTokenClient({
                client_id: clientId,
                scope: this.googleScope,
                callback: (token) => {
                    if (token && token.access_token) {
                        token.expiresDateTime = new Date();
                        token.expiresDateTime.setMinutes(token.expiresDateTime.getMinutes() + 59);
                        this.userService.googleUser = token;
                        this.validateGoogleToken(token.access_token, enterClick, 'googleIdentity_oAuth');
                    }
                    else {
                        this.loginError = 'Invalid Google login.';
                        this.loginWithGoogle = false;
                    }
                },
            });

            client.requestAccessToken();
        }
    }

    validateGoogleToken(token: string, enterClick: boolean, grantType: string) {
        // If this is a bad browser, show the warning and exit
        if (this.badBrowser) {
            this.dialog.open(UnsupportedBrowserWarningDialogComponent, {
                disableClose: true
            });
            this.userService.googleUser = null;
            return;
        }

        // Validating ID token
        // NOTE: we have to run this in the zone or it won't trigger change detection
        this.zone.run(() => {
            const subscription = this.loginService.logonGoogle(token, this.userType, grantType).subscribe(
                user => {
                    // If valid, log in
                    if (localStorage) {
                        localStorage.setItem('UserType', user.userType);
                    }
                    sessionStorage.setItem('accessToken', user.access_token);

                    if (user.userType == '1') {
                        this.getGeneralPreferences(enterClick);
                        if (!this.loginSettings.V10) {
                            this.getDefaultYear(this.userService.userId);
                        }
                    } else {
                        this.getUser(enterClick);
                    }
                    this.loginService.hasSignedIntoGoogle = true;

                    // Unsubscribing to prevent leaks
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                },
                () => {
                    this.loginFromLegacy = false;
                    this.loginError = 'Matching SIS user not found.';
                    this.userService.googleUser = null;
                }
            );
        });
    }

    v9TIDAuthentication(enterClick: boolean) {
        this.authService.getUser().then((u) => {
            if (u) {
                const subscription = this.loginService
                    .logonTID(u.id_token, this.userType)
                    .subscribe(
                        (user) => {
                            // If valid, log in
                            this.loginFromLegacy = true; // Sri - this is copied from loginbuttonclick method line 396 doesn't make sense.
                            if (user.userName != undefined && user.userName != null) {
                                this.loginService.hasSignedIntoTylerId = true;
                                this.setLocalStorage(user, enterClick);
                            } else {
                                this.loginError = 'Invalid Username or Password.';
                                this.loginFromLegacy = false;
                            }
                        },
                        (err) => {
                            this.isLoggedIn = false;
                            this.userService.isLoggedIn.next(false);
                            this.userService.username = '';
                            this.userService.userId = 0;
                            this.userService.firstname = '';
                            this.userService.lastname = '';
                            this.userService.userType = 0;
                            this.userService.studentId = 0;
                            this.loginFromLegacy = false;
                            if (err instanceof HttpErrorResponse && err.status == 400) {
                                this.loginError = 'Invalid Username or Password.';
                            } else {
                                this.loginError = 'There was an error during the login process.';
                                this.loginService.observableLoginError.next(err);
                            }
                        });
            }
        });
    }

    redirectUserTo360() {
        this.isLoggedIn = true;
        this.userService.isLoggedIn.next(true);
        this.userService.username = this.userService.currentUser.UserName;
        this.userService.firstname = this.userService.currentUser.FirstName;
        this.userService.lastname = this.userService.currentUser.LastName;
        this.userService.userId = this.userService.currentUser.Id;
        this.userService.userType = this.userService.currentUser.UserType;
        this.userService.studentId = this.userService.currentUser.StudentId;
        let userId = this.userService.userId;
        if (this.userService.userType == 3 && userId == 0) {
            userId = this.userService.studentId;
        }
        if (sessionStorage.getItem('loginFromLegacy') == null || sessionStorage.getItem('loginFromLegacy') != '1') {
            this.saveUserLoginInfo(userId);
        }
        if (this.userService.userType != 1) {
            this.setUserLanguage();
        }
        this.getUserYears();
    }

    @HostListener('document:keydown.enter', ['$event'])
    onEnterKeyDown(event: KeyboardEvent) {
        if (!this.isLoggedIn) {
            this.LoginButtonClick(true);
        }
    }
}
